import { Component } from '@angular/core';
//import * as ConnectWise from '../../../assets/js/ConnectWiseHostedAPI.1.0.js';

declare var ConnectWiseHostedAPI: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent {

  public test: string;
  public connectWiseClientApi: any;
  public connectWiseAuth: any;

  ngOnInit() {
    this.test = 'set';
    this.initialize();
  }

  ngAfterViewInit() {

  }

  checkAuth() {
    alert('NOW' + this.connectWiseAuth.companyid);
    console.log(this.connectWiseAuth);
  }

  getAuth() {

    console.log('auth test');

    this.connectWiseClientApi.post({ "request": "getMemberAuthentication" },  (screen, id) => {

      console.log('auth');
      console.log(screen);

      this.connectWiseAuth = screen;
    });
  }

  initialize() {

    console.log('start init');
    console.log(ConnectWiseHostedAPI);

    // instantiate ConnectWiseHostedApi passing in the ConnectWise Origin domain and a collection of event handlers.
    this.connectWiseClientApi = new ConnectWiseHostedAPI("https://staging.connectwisedev.com",
      {
        "eventHandlers": [
          { "event": "connected", "callback": (id) => { this.connected(id); } },
          { "event": "onLoad", "callback": this.onLoad },
          { "event": "beforeSave", "callback": this.beforeSave },
          { "event": "beforeBack", "callback": this.beforeBack }
        ]
      }, true
    );

    console.log(this.connectWiseClientApi);

    console.log('ending init');
  }

  connected(id) {

    this.getAuth();

  }

  onLoad(screen, id) {

    console.log('onLoad');
    console.log(screen);
    console.log(id);

    //connectWiseAuth = screen;

  }

  beforeSave(screen, id, resultCallback) {

  }

  beforeBack() {

  }
}
